import {
    CartStep2ProductInterface,
    CartStep2ProductResponseInterface,
} from '@/core/domain/cart-step2/models/cart-step2-product.model';
import { CartStep2ProductRepository } from '@/core/domain/cart-step2/repositories/cart-step2-product.repository';
import { environment } from '@/env/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class CartStep2ProductImplRepository extends CartStep2ProductRepository {
    constructor(private readonly httpClient: HttpClient) {
        super();
    }

    override sendCartStep2Product(
        array: CartStep2ProductInterface,
    ): Observable<CartStep2ProductResponseInterface> {
        return this.httpClient.post<CartStep2ProductResponseInterface>(
            [
                environment.alamoApi.BASE_HOST,
                environment.alamoApi.ENDPOINTS.cartProducts,
            ].join('/'),
            array,
        );
    }
}
